import React from 'react';
import { Dropdown } from 'antd';
import { GlobalOutlined, DownOutlined } from '@ant-design/icons';
import { useT } from './I18nContext';

/**
 * Header'da gösterilecek dil seçici dropdown.
 *
 * Antd Dropdown menü kullanır — flag emoji + label ile 8 dil.
 * Aktif dil bayrağı buton üzerinde, açıldığında listede ✓ ile işaretli.
 */
const LanguageSwitcher = ({ size = 'default', minimal = false }) => {
    const { lang, pendingLang, setLang, t, langs } = useT();
    // Seçim ANINDA işaretlenir: sözlük birkaç yüz ms sonra gelip dili uyguladığında
    // menü zaten doğru dili gösteriyor olur (yoksa tıklama tepkisiz görünürdü).
    const shown = pendingLang || lang;
    // Liste InitApp'tan gelir; henüz gelmediyse en azından aktif dili göster.
    const active = langs.find(l => l.code === shown) || { code: shown, label: String(shown).toUpperCase(), flag: '🌐' };

    const items = langs.map(l => ({
        key: l.code,
        label: (
            <span style={{
                display: 'flex', alignItems: 'center', gap: 8,
                padding: '2px 4px',
                fontWeight: l.code === shown ? 600 : 400,
            }}>
                <span style={{ fontSize: 16 }}>{l.flag}</span>
                <span>{l.label}</span>
                {l.code === shown && <span style={{ marginLeft: 'auto', color: '#52c41a' }}>✓</span>}
            </span>
        ),
        onClick: () => setLang(l.code),
    }));

    return (
        <Dropdown
            menu={{ items, selectedKeys: [shown] }}
            trigger={['click']}
            placement='bottomRight'
        >
            <button type='button'
                title={t('common.language')}
                aria-label={t('common.language')}
                style={{
                    display: 'inline-flex', alignItems: 'center', gap: 6,
                    background: 'transparent', border: 'none',
                    cursor: 'pointer',
                    padding: minimal ? '4px 6px' : '6px 10px',
                    borderRadius: 8,
                    fontSize: size === 'small' ? 12 : 13,
                    color: '#1f2937',
                }}
                onMouseEnter={(e) => { e.currentTarget.style.background = '#f3f4f6'; }}
                onMouseLeave={(e) => { e.currentTarget.style.background = 'transparent'; }}
            >
                <GlobalOutlined style={{ fontSize: 16, color: '#9ca3af' }} />
                <span style={{ fontSize: 16 }}>{active.flag}</span>
                {!minimal && <span style={{ fontWeight: 500 }}>{active.label}</span>}
                <DownOutlined style={{ fontSize: 9, color: '#9ca3af' }} />
            </button>
        </Dropdown>
    );
};

export default LanguageSwitcher;
